import { Box, Grid, Paper } from '@mui/material';
import { useFieldArray } from 'react-hook-form';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Frequency from './Frequency';
import Resolution from './Resolution';
import UTextField2 from '../../utils/UTextField2';

const defaultFrequency = '0 */5 * * * *';
const defaultResolution = '1920x1080';
const defaultPriority = '13';
const defaultWait = '2000';

export default function FrameCapturesComponent() {
  const { fields, append, remove, insert } = useFieldArray({
    name: 'frameCaptures',
  });
  const defaultValue = {
    ref: '',
    priority: defaultPriority,
    cron: defaultFrequency,
    size: defaultResolution,
    pan: '',
    tilt: '',
    zoom: '',
    wait: defaultWait,
  };

  return (
    <>
      {fields.length == 0 && (
        <Grid item xs={12}>
          <Paper style={{ backgroundColor: '#d0e6ff', padding: '16px 10px' }}>
            <Grid container spacing={2}>
              <Grid container item xs={12}>
                <Grid item xs>
                  <h1 style={{ fontSize: '14px', margin: 0 }}>Frame captures</h1>
                </Grid>
                <Grid item xs={1}>
                  <AddCircleIcon
                    onClick={() => {
                      append(defaultValue);
                    }}
                    style={{ cursor: 'pointer' }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      )}
      {fields.map((field, index) => {
        const add = () => {
          insert(index + 1, defaultValue);
        };
        const del = () => {
          remove(index);
        };
        return (
          <Grid key={field.id} item xs={12}>
            <Paper style={{ backgroundColor: '#d0e6ff', padding: '16px 10px' }}>
              <Grid container spacing={2}>
                <Grid container item xs={12}>
                  <Grid item xs>
                    {index == 0 && <h1 style={{ fontSize: '14px', margin: 0 }}>Frame captures</h1>}
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <UTextField2
                    name={`frameCaptures.${index}.ref` as `frameCaptures.0.ref`}
                    options={{
                      required: 'a value is required',
                    }}
                    fullWidth
                    label="Reference"
                    shrink={true}
                    defaultValue=""
                    required
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Resolution
                    required
                    defaultValue={'1920x1080'}
                    name={`frameCaptures.${index}.size` as `frameCaptures.0.size`}
                  />
                </Grid>

                <Grid item xs={6} sm={3}>
                  <UTextField2
                    name={`frameCaptures.${index}.pan` as `frameCaptures.0.pan`}
                    options={{
                      min: { value: -180, message: 'Should be > -180' },
                      max: { value: 180, message: 'Should be < 180' },
                      valuesAsNumber: true,
                    }}
                    fullWidth
                    label="Pan"
                    shrink={true}
                    defaultValue=""
                  />
                </Grid>
                <Grid item xs={6} sm={3}>
                  <UTextField2
                    name={`frameCaptures.${index}.tilt` as `frameCaptures.0.tilt`}
                    options={{
                      min: { value: -90, message: 'Should be > -90' },
                      max: { value: 90, message: 'Should be < 90' },
                      valuesAsNumber: true,
                    }}
                    fullWidth
                    label="Tilt"
                    shrink={true}
                    defaultValue=""
                  />
                </Grid>
                <Grid item xs={6} sm={3}>
                  <UTextField2
                    name={`frameCaptures.${index}.zoom` as `frameCaptures.0.zoom`}
                    options={{
                      min: { value: 0, message: 'Should be > 0' },
                      max: { value: 10e6, message: 'Should be < 10E6' },
                      valuesAsNumber: true,
                    }}
                    fullWidth
                    label="Zoom"
                    shrink={true}
                    defaultValue=""
                  />
                </Grid>

                <Grid item xs={6} sm={3}>
                  <UTextField2
                    name={`frameCaptures.${index}.wait` as `frameCaptures.0.wait`}
                    options={{
                      min: { value: 0, message: 'Should be > 0' },
                      max: { value: 10000, message: 'Should be < 10000' },
                      valuesAsNumber: true,
                      required: 'value required',
                    }}
                    fullWidth
                    label="Wait"
                    shrink={true}
                    defaultValue={2000}
                    type="number"
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Frequency
                    required={true}
                    defaultValue="0 */15 * * * *"
                    name={`frameCaptures.${index}.cron` as `frameCaptures.0.cron`}
                  />
                </Grid>
                <Grid item xs={6} sm={3}>
                  <UTextField2
                    name={`frameCaptures.${index}.priority` as `frameCaptures.0.priority`}
                    options={{
                      min: { value: 1, message: 'Should be > 0' },
                      max: { value: 100, message: 'Should be < 100' },
                      valuesAsNumber: true,
                      required: 'value required',
                    }}
                    fullWidth
                    label="Priority"
                    shrink={true}
                    defaultValue={13}
                    type="number"
                    required
                  />
                </Grid>

                <Grid container item alignItems="center" justifyContent="center" xs={3}>
                  <Box display="flex" flexDirection="column">
                    <AddCircleIcon onClick={add} style={{ cursor: 'pointer' }} />
                    <RemoveCircleIcon onClick={del} style={{ cursor: 'pointer' }} />
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        );
      })}
    </>
  );
}
